module.exports = __webpack_public_path__ + "img/google-logo.54d92439.png";